import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import datePicker from '_c/date-picker';
import depart from '@/components/department';
import { exportMore, getBuildInTypes, configFn } from 'api/approval/search';
var form = function form() {
  return {
    state: '',
    audit_type: '',
    create_date_start: '',
    create_date_end: '',
    submitter_department_id: '',
    finish_date_start: '',
    finish_date_end: '',
    date_type: 1
  };
};
export default {
  components: {
    datePicker: datePicker,
    depart: depart
  },
  props: {
    stateArr: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      exportLoading: false,
      form: form(),
      typeArr: [],
      upDate: true,
      isMultiple: '',
      createDate: [],
      finishDate: []
    };
  },
  computed: {
    isExport: function isExport(vm) {
      return vm.form.create_date_end && vm.form.create_date_start || vm.form.finish_date_start && vm.form.finish_date_end && vm.form.audit_type;
    }
  },
  watch: {
    // 解决切换时间类型时报错
    isMultiple: function isMultiple() {
      var _this = this;
      this.upDate = false;
      setTimeout(function () {
        _this.upDate = true;
      });
    }
  },
  methods: {
    init: function init() {
      this.visible = true;
      this.form = form();
      this.changeType();
    },
    // 部门级连选择
    selectDepart: function selectDepart(_, current) {
      this.form.submitter_department_id = current.map(function (item) {
        return item.slice(-1)[0];
      });
    },
    // 导出查询结果
    doSubmit: function doSubmit() {
      var _this2 = this;
      this.exportLoading = true;
      exportMore(this.form).then(function (res) {
        _this2.$message.success(res.message);
        _this2.visible = false;
      }).finally(function () {
        return _this2.exportLoading = false;
      });
    },
    changeType: function changeType(val) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _ref, _ref2, _res, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ;
              _ref = ['', ''];
              _this3.form.create_date_start = _ref[0];
              _this3.form.create_date_end = _ref[1];
              _ref2 = ['', ''];
              _this3.form.finish_date_start = _ref2[0];
              _this3.form.finish_date_end = _ref2[1];
              _this3.form.submitter_department_id = '';
              _this3.form.audit_type = '';
              _this3.finishDate = [];
              _this3.createDate = [];
              if (!(val === 2)) {
                _context.next = 18;
                break;
              }
              _context.next = 14;
              return getBuildInTypes();
            case 14:
              _res = _context.sent;
              _this3.typeArr = _res.data.map(function (v) {
                return {
                  label: v.value,
                  value: v.code
                };
              });
              _this3.isMultiple = false;
              return _context.abrupt("return");
            case 18:
              _context.next = 20;
              return configFn();
            case 20:
              res = _context.sent;
              if (res && res.code === 1) {
                _this3.typeArr = res.data.audit_type.map(function (v) {
                  return {
                    label: v.value,
                    value: v.code
                  };
                });
              }
              _this3.isMultiple = true;
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};